import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Owner = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      clipRule="evenodd"
      d="M3.10466 2.8416L5 4.50003L7.24074 1.88583C7.63984 1.42022 8.36016 1.42022 8.75926 1.88583L11 4.50003L12.8953 2.84161C13.6022 2.22311 14.6947 2.83212 14.5402 3.75858L13.5 10H2.5L1.45976 3.75858C1.30535 2.83212 2.3978 2.22311 3.10466 2.8416ZM12.8308 4.89126L12.2293 8.50003H3.77069L3.16923 4.89126L5.15269 6.62678L8 3.30492L10.8473 6.62678L12.8308 4.89126Z"
      fill="currentColor"
      fillRule="evenodd"
    />
    <path d="M13.5 15V13.5H2.5V15H13.5Z" fill="currentColor" />
    <path d="M2.5 11H4V12.5H2.5V11Z" fill="currentColor" />
    <path d="M7 11H5.5V12.5H7V11Z" fill="currentColor" />
    <path d="M9 11H10.5V12.5H9V11Z" fill="currentColor" />
    <path d="M13.5 11H12V12.5H13.5V11Z" fill="currentColor" />
  </Icon>
));

export default Owner;
